// @flow
import LocationData from 'insight/pages/general/LocationData';
import PageContainer from 'insight/pages/common/PageContainer';
import PageTitle from '../../../common/components/PageTitle';

const GeneralOverview = (): React$Node => {
  return (
    <PageContainer>
      <PageTitle titleKey={'app.page.title.general.overview'} />
      <LocationData />
    </PageContainer>
  );
};

export default GeneralOverview;
